import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'
import 'firebase/database'


import { formatCurrency } from '../utils'
import { PLATFORMCOLOR } from '../globals'


const PlatformPriceContainer = styled.div`
  font-size: 0.9rem;
  color: #666;
  /*border: ${({ productstatus, stockstatus }) =>
    `1px solid ${productstatus === 'B'
      ? '#db2828'
      : productstatus === 'E'
        ? '#f2711c'
        : stockstatus === 'full'
          ? '#409142'
          : stockstatus === 'half'
            ? '#f2711c'
            : '#db2828'
    }`};*/
    border: ${`1px solid ${PLATFORMCOLOR.dark}`};
  border-radius: 0.3rem;
  padding: 0.4rem 0.8rem 0.4rem 0.4rem;
  text-align: center;
  display: inline-block;
  &:hover {
    cursor: ${({ productstatus }) => (productstatus === 'E' ? 'pointer' : 'auto')};
  }
`
/*const PlatformPriceIcon = styled(Icon).attrs(() => ({ size: 'large' }))`
  color: ${PLATFORMCOLOR.dark};
  margin-right: 0.1em !important;
`*/
const PlatformPriceStatus = styled.span`
  color: ${PLATFORMCOLOR.dark};
  font-weight: bold;
`

/**
 * Component: PlatformPrice
 * Description.
 */
const PlatformPriceWidget = React.memo(
  ({
    platformName,
    platformPrice,
    ...restProps
  }) => {

    if (!platformName || !platformPrice)
      return null

    return (
      <PlatformPriceContainer {...restProps}>
        {/*<PlatformPriceIcon name="info" stockstatus="full" />*/}
        <PlatformPriceStatus>
          {platformName}: {formatCurrency(platformPrice.pvp)} 
        </PlatformPriceStatus>
      </PlatformPriceContainer>
    )
  }
)

PlatformPriceWidget.propTypes = {
  platformName: PropTypes.string,
  platformPrice: PropTypes.object,
}

PlatformPriceWidget.defaultProps = {
  platformName: 'Plataforma',
  platformPrice: null,
}

export default PlatformPriceWidget
